$(".collection_slider").slick({
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      }
    }
  ]
});

$(".testii_slider").slick({
  autoplay: true,
  autoplaySpeed: 0,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  variableWidth: true,
  cssEase: "linear",
  speed: 10000,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        infinite: true,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      }
    }
  ]
});

$(".insight_slider").slick({
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      }
    }
  ]
});


$('.portfolio_slider').slick({
  autoplay: true,
  autoplaySpeed: 0,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  cssEase: 'linear',
  speed: 10000,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      }
    }
  ]
});


// Responsive Menu 

  $(document).ready(function () {

    $('.open_menu').click(function () {
      $('.side_menu').addClass('show');
      $('.responsive_overly').addClass('show');
    });

    $('.close_menu').click(function () {
      $('.side_menu').removeClass('show');
      $('.responsive_overly').removeClass('show');
    });

  });

  var header = document.getElementById("menu_logo");
  var sticky = header.offsetTop;

  window.addEventListener("scroll", function () {
    if (window.pageYOffset > sticky) {
      header.classList.add("menu_sticky");
    } else {
      header.classList.remove("menu_sticky");
    }
  }); 